export default {
    milestones: state => state.milestones,
}
